//#region src/core/ui/title/core.ts
/** @internal */
var TitleCore = class {
	getState(media, controls) {
		const { title } = media;
		return {
			title,
			hidden: title.length === 0,
			visible: controls?.controlsVisible ?? false
		};
	}
};
//#endregion
export { TitleCore };

//# sourceMappingURL=core.js.map